import React from 'react'

import Congrats from '../images/Congratulations.svg'
import Close from '../images/Close.svg'

function Congratulations({toggleCongratulations}) {
    return (
        <div className="ThankYou">
            <div className="ThankYou__Content">
                <div className="ThankYou__Content__Close" onClick={()=>toggleCongratulations()}>
                    <img src={Close} alt="" />
                </div>
                <div className="ThankYou__Content__Top">
                    <img src={Congrats} alt="" />
                </div>
                <div className="ThankYou__Content__Body">
                    <div className="ThankYou__Content__Body--Heading">Congratulations!</div>
                    <div className="ThankYou__Content__Body--Text">
                    We have recieved your request for call back. A Classplus representative will soon get in touch with you to explain how you can become part of Classplus Teachers' Biographies. We look forward to hearing your story!
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Congratulations
